import React from 'react';
import FormErrors from '../components/FormErrors';
import { Modal, Button, ModalHeader, Card } from 'react-bootstrap';
import LoadingComponent from '../components/LoadingComponent';
import SavingComponent from '../components/SavingComponent';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import UserService from '../services/UserService';
import { FormattedMessage } from 'react-intl';
import Messages from '../messages';
import {MdAdd, MdAttachFile, MdCheckBox, MdCheckBoxOutlineBlank, MdCloudDownload, MdDeleteForever, MdFileUpload, MdFileDownload, MdCloudUpload, MdFormatUnderlined} from 'react-icons/lib/md';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';

import "react-toggle/style.css";
import Toggle from 'react-toggle';

import 'jspdf-autotable';
import Footer from '../components/Footer';

import OidcProvider from '../services/OidcProvider';
import NavBar from '../components/NavBar';

import { ApiService } from '../services/ApiService';
import { head } from 'lodash';
import {DocumentUploadModal} from "../components/documents/DocumentUploadModal";
import Badge from "react-bootstrap/Badge";
import OrderService from "../services/OrderService";

const uploadPdfButtonColor = 'DeepSkyBlue';
const globalMessages = Messages;
const apiFlagFINISHED_PROCESSING = 'FINISHED_PROCESSING';
const apiFlagERROR_PROCESSING = 'ERROR_PROCESSING';
const apiFlagASSIGN_UPLOAD_COMPLETE = 'Upload complete';
const MAX_TIME_WAITED = 10000;
const MAX_PROFILE_NAME_LENGTH = 40;

const certblockAPI = new ApiService();
const orderService = new OrderService();
const TP_DPROF15 = '000015';
const TP_DPROF370 = '000370';

export class UploadDocumentsContainer extends React.Component {

    constructor(props) {

        super(props);
        this.apiConfig = window.ApiConfig;
        this.deliveryNumberInput = React.createRef();

        this.state = {
            isSiemensOrSupplier: true,
            certificateId: '',
            supplier: '',
            orderNumber: '',
            deliveryNumber: '',
            orderPosition: '',
			// orderNumber typeahead options
			orderNumberSearchOptions: [],
            materialNumber: '',
            materialDescription: '',
            quantity: '',
            serialNumber: '',
            nameInspector: '',
            inspectionDate: moment(),
            confirmationText: '',
            confirmation: '',
            checkTestsResults: '',
            materialList: [],
            certificateList: [],
            supplierData: {
                name: '',
                street: '',
                zip: '',
                city: '',
                country: ''
            },
            consigneeIndex: null,
            consigneeData: {
                name: '',
                street: '',
                zip: '',
                city: '',
                country: ''
            },
            showModal: false,
            showLoadingModal: false,
            showSavingModal: false,
            setPlaceHolderValue: false,
            formErrors: {
                supplier: '',
                orderNumber: '',
                deliveryNoteNumber: '',
                deliveryNumber: '',
                orderPosition: '',
                materialNumber: '',
                materialDescription: '',
                quantity: '',
                serialNumber: '',
                nameInspector: '',
                inspectionDate: '',
                confirmationText: '',
                confirmation: ''
            },
            deliveryNoteNumber: '',
            defaultDeliveryNoteNumber: '',
            orderNumbersForSupplier: [],
            materials: [],
            orderPositionSelected: '',
            supplierNumber: '',
            isLoadingPrefix: false,
            apiErrorMessage: '',
            apiErrorMessageForDevelopers: '',
            materialSelected: undefined,
            showAddSerialNumbersModal: false,
            useSerialNumbers: false,
            serialNumberAutoInc: false,
            addedSerialNumbersDict: {},
            withoutSNdict: {}, //used to store files in case of no SN added 
            docProfiles: undefined
        };

    }

    setSupplierNumber() {
        const IAM_API = certblockAPI.getIAM_API(this.getUser().id_token);
        IAM_API.userCurrent()
        .then((certblockUser) => {
            this.setState({
                // testerList: certblockUser.data.testers ? certblockUser.data.testers : [],
                // tests: certblockUser.data.materialTests ? certblockUser.data.materialTests : [],
                supplierNumber: certblockUser.data.supplier ? certblockUser.data.supplier : ''
            });
        }).catch((error) => {
            this.setState({
                showAPIErrorModal: true,
                showLoadingModal: false,
                showSavingModal: false,
                apiErrorMessage: globalMessages[localStorage.getItem('language')].createCertificate.uiErrorMessageFailAPICall
            });
        });

    }

    
    componentDidMount() {
        this.getRole();
        this.setSupplierNumber();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.supplierNumber !== '' && this.state.supplierNumber !== prevState.supplierNumber) {
            this.getOrderNumbers(this.state.supplierNumber);
        }
    }    

    getDirectLinkCertificate = () => {


        const oNr = sessionStorage.getItem("orderNumber");
        // console.log(`DEBUG: [orderNumberFromStaticLink] ${oNr}`)
        const oPos = sessionStorage.getItem("orderPosition");
        const dBr = sessionStorage.getItem("deliveryNumber");
        if (oNr && oPos && dBr) {
            this.setState({
                showLoadingModal: true
            });
          
            const CRT_API = certblockAPI.getCRT_API(this.getUser().id_token);
            CRT_API.getCertificateId(oNr, oPos, dBr)
                .then((certificate) => {
                    this.setState({
                        showLoadingModal: false
                    });

                    sessionStorage.removeItem("orderNumber");
                    sessionStorage.removeItem("orderPosition");
                    sessionStorage.removeItem("deliveryNumber");

                    this.showCertificate(certificate.data, 0);
                })
                .catch(() => {
                    this.setState({
                        showLoadingModal: false
                    });

                    sessionStorage.removeItem("orderNumber");
                    sessionStorage.removeItem("orderPosition");
                    sessionStorage.removeItem("deliveryNumber");
                    console.error('Certificate not found');
                });
        }

    };

    getRole = () => {
        const oidc = new OidcProvider();
        const user = oidc.getUser();

        if (user.role === 'userSupplier') {
            this.setState({ isSupplier: true });
        }

    }

    handleKeyUp = (e) => {
        if (e == null || e.target.name !== "orderNumber") return;

        switch (e.key) {
            case "Enter":
            case "Return": {
                this.getCertificates();
                break;
            }
        }
    };


    handleChange = (e) => {
        let name;
        let value;

        if (e != null) {

            name = e._isAMomentObject ? "inspectionDate" : e.target.name;
            value = e._isAMomentObject ? e : (e.target.type === "checkbox" ? e.target.checked : e.target.value);

            switch (name) {
                case "orderNumber": {
                    this.setState({ orderNumber: value });
                    break;
                }
                case "deliveryNoteNumber": {
                    this.setState({ deliveryNoteNumber: value},()=>{
                        // console.log('defaultDeliveryNoteNumber:' + this.state.defaultDeliveryNoteNumber);
                        // console.log('deliveryNoteNumber:' + this.state.deliveryNoteNumber);
                    });
                    break;
                }
                case "setPlaceHolderValue": {
                    let today = new Date();
                    let myDate =  today.getFullYear() 
                                    + ('0' + (today.getMonth()+1)).slice(-2) 
                                    + ('0' + today.getDate()).slice(-2);
                    this.setState({setPlaceHolderValue: value},()=>{
                        if(this.state.setPlaceHolderValue) {
                            this.setState({
                                defaultDeliveryNoteNumber: myDate
                            },()=>{
                                // console.log('defaultDeliveryNoteNumber:' + this.state.defaultDeliveryNoteNumber);
                                // console.log('deliveryNoteNumber:' + this.state.deliveryNoteNumber);
                            })
                        } else {
                            this.setState({
                                defaultDeliveryNoteNumber: ''
                            },()=>{
                                // console.log('defaultDeliveryNoteNumber:' + this.state.defaultDeliveryNoteNumber);
                                // console.log('deliveryNoteNumber:' + this.state.deliveryNoteNumber);
                            })
                        }
                    });
                    break;
                }
                default: {
                    break;
                }
            }
        }
    };


    getUser = () => {
        return JSON.parse(localStorage.getItem('oidc_user'));
    };

    getCertificates = () => {
        this.setState({
            showLoadingModal: true
        });

        const CRT_API = certblockAPI.getCRT_API(this.getUser().id_token);

        CRT_API.getCertificateIdList(this.state.orderNumber)
        .then((certificates) => {
            console.log(`[certificateGet] ${JSON.stringify(certificates.data)}`);
            this.setState({
                certificateList: certificates.data,
                showLoadingModal: false
            });
        })
        .catch((error) => {
            console.error(error);
            this.setState({
                showLoadingModal: false
            });
        });

    };

    showCertificate = (id, version) => {

        this.setState({
            showLoadingModal: true
        });

        // console.log(`DEBUG: [id/version] ${id}/${version}`);
        const CRT_API = certblockAPI.getCRT_API(this.getUser().id_token);

        CRT_API.getCertificateSiemensById(id, version)
        .then((certificate) => {
            this.setState({
                showLoadingModal: false,
                showModal: true,
                supplierData: certificate.data.creator,
                orderNumber: certificate.data.orderNumber,
                deliveryNumber: certificate.data.deliveryNumber,
                materialList: certificate.data.materialList,
                nameInspector: certificate.data.nameInspector,
                inspectionDate: certificate.data.inspectionDate,
                confirmationText: certificate.data.confirmationText,
                confirmation: certificate.data.checkConfirmation,
                checkTestsResults: certificate.data.checkTestsResults,
                consigneeData: certificate.data.consignee,
                orderPosition: certificate.data.materialList[0].orderPosition
            });
        })
        .catch((error) => {
            console.error(error);
            this.setState({
                showLoadingModal: false
            });
        });
    
    };

    getChunksFromString = (str, chunkSize) => {
    var regexChunk = new RegExp(`.{1,${chunkSize}}`, 'g')   // '.' represents any character
        return str.match(regexChunk)
    }

    //scaffold of function splitting headers into chunks with white speaces to be displayed in column headers
    adjustHeader = (header, howManyHeaders) => {
        console.log(`DEBUG[adjustHeader] header: ${header} howManyHeaders: ${howManyHeaders}`);
        var modal = document.getElementsByClassName('modal-dialog');
        // clientHeight: 430
        // clientLeft: 0
        // clientTop: 0
        // clientWidth: 900

        // offsetHeight: 430
        // offsetLeft: 641
        // offsetParent
        // : 
        // div.modal
        // offsetTop: 363
        // offsetWidth: 900

        // scrollHeight: 430
        // scrollLeft: 0
        // scrollTop: 0
        // scrollWidth: 900        
        // var modal_width = modal.offsetWidth
        // var modal_height = modal.offsetHeight;
        // var window_width = window.innerWidth;
        // var window_height = window.innerHeight;
        // console.log(`modal_width: ${modal_width} window_width: ${window_width}`);
        // let chunks = this.getChunksFromString(header,6);
        // console.table(chunks);
        // let cutText = chunks.reduce((acc,el)=> acc+=el+" \n","");
        // console.log(cutText);
        // return cutText;   //ready to split for chunks to fill in column width 
        return header;
    }

    countSelectedFiles = () => {
    console.log(`DEBUG[countSelectedFiles]`);
        if (!this.SNallowed()) { 
            let files4all = this.state.withoutSNdict;
            let count = Object.keys(files4all).reduce((acc,key)=>{
                return  acc + (((key != 'SN') && this.cellHasFiles(files4all[key]))? 1 : 0);
            },0);
            return count;
        }

        let dataDict = this.state.addedSerialNumbersDict;
        let profiles = Object.keys(dataDict);
        let subSumy = profiles.map((profile)=>{
            return (profile != 'SN')? dataDict[profile].reduce((acc,file)=> {return acc + (this.cellHasFiles(file)? 1 : 0)},0) : 0;
        });
        return subSumy.reduce((acc,el)=>acc+el,0);
    }

    //a cell holds an (ordered) array of selected files. It counts as filled when it contains at least one file.
    cellHasFiles = (cell) => {
        return Array.isArray(cell) && cell.length > 0;
    }

    alreadySelected = (col, row) => {
        let dataDict = this.state.addedSerialNumbersDict;
        let files4all = this.state.withoutSNdict;
        if(row == -1 ) {
            // console.log(files4all);
            return this.cellHasFiles(files4all[col]);
        }
        return this.cellHasFiles(dataDict[Object.keys(dataDict)[col]][row]);
    }
  
    handleFileChange = async (event) => {
        console.log(`DEBUG[handleFileChange]`);
        console.log(event.target.value);
        let col = event.target.attributes.col.value; 
        let row = event.target.attributes.row.value;
        console.log(`(row,col) (${row},${col})`)
        let currentSNDict = this.state.addedSerialNumbersDict;
        let currentWithoutSNdict = this.state.withoutSNdict;
        let selectedFiles = Array.from(event.target.files);
        if(row == -1) {
            // currentSNDict[col][currentSNDict[col].length-1] = selectedFiles;
            currentWithoutSNdict[col] = selectedFiles;
            if (this.SNallowed()) {
                for(let i = 0; i < currentSNDict[col].length; i++){
                    currentSNDict[col][i] = selectedFiles;
                }
            }
        } else {
            currentSNDict[col][row] = selectedFiles;
        }
        this.setState({
            addedSerialNumbersDict: currentSNDict,
            withoutSNdict: currentWithoutSNdict
        },()=>{
            console.log(this.state.addedSerialNumbersDict);
            console.log(this.state.withoutSNdict);
        });
    }

    errorClass = (error) => {
        return (error.length === 0 ? '' : 'is-invalid');
    };


    handleChangeOrderNumber = async (value) => {
        console.log(`DEBUG  [handleChangeOrderNumber] value: ${value}`);
        await this.getMaterials(value,(returnedMaterials)=>{
            let serialNumbersDict = {};
            returnedMaterials.forEach((material)=>{
                serialNumbersDict[material.orderPosition] = [''];
                //if prrofile 000015 and 000370 exlusion of 000370 below 
                let arrayOfProfiles = material.TP_DPROF.split(',');
                if((arrayOfProfiles.indexOf(TP_DPROF15) >= 0) && (arrayOfProfiles.indexOf(TP_DPROF370) >= 0)){
                    arrayOfProfiles.splice(arrayOfProfiles.indexOf(TP_DPROF370),1);
                    material.TP_DPROF = arrayOfProfiles.join(',');
                    material.PROF370_DELETED = true;
                    console.log(`DEBUG  [handleChangeOrderNumber] 15 and 370 profile present; 370 is taken out`);
                }
            });
            console.log(serialNumbersDict);
            this.setState({
                orderNumber: value,
                materials: returnedMaterials,
                orderPositionSelected: '',
                addedSerialNumbersDict: serialNumbersDict
            },()=>{
                console.log(this.state.materials);
            });
        })
        await this.updateStatuses();
    }   

    handleAddSerialNumberChanged = (e, idx) => {
        console.log(`DEBUG  [handleAddSerialNumberChanged]`);
        console.log(`this.state.orderPositionSelected: ${this.state.orderPositionSelected}`);
        let addedValuesDict = this.state.addedSerialNumbersDict;
        addedValuesDict['SN'][idx] = e.target.value;
        this.setState({
            addedSerialNumbersDict: addedValuesDict
        },()=>{
            console.log(this.state.addedSerialNumbersDict);
        });
    }


    handleAddDefaultSerialNumbers = () => {
        console.log(`DEBUG  [handleAddDefaultSerialNumbers] `);
        let addedValuesDict = this.state.addedSerialNumbersDict;
        let addedValuesInDict = addedValuesDict['SN'];
        if (addedValuesInDict.length === 1) return;
        const myRegex = /(\d+)(?!.*\d)/;
        
        let theLastNumber = addedValuesInDict[0].match(myRegex);
        console.log(`theLastNumber: ${theLastNumber}`);

        if(!theLastNumber) {
            return;
        }
        let numericSNPartLength = theLastNumber[0].length;

        for(let i = 1; i < addedValuesInDict.length; i++){
            // addedValues[i] = addedValues[0]+"_"+i;
            addedValuesInDict[i] = addedValuesInDict[0].replace(myRegex,`${theLastNumber[0]*1 + i}`.padStart(numericSNPartLength, "0"));
        }
        addedValuesDict['SN'] = addedValuesInDict;
        this.setState({
            addedSerialNumbersDict: addedValuesDict
        },()=>{
            // console.log(this.state.addedSerialNumbers);
            console.log(this.state.addedSerialNumbersDict);
        });
    }

    handleSerialNumberAutoIncChange = () =>{
        console.log(`DEBUG  [handleSerialNumberAutoIncChange] `);
        this.setState({serialNumberAutoInc: !this.state.serialNumberAutoInc},()=>{
            console.log(`this.state.serialNumberAutoInc: ${this.state.serialNumberAutoInc}`);
        });
    }


    checkProfileStatus = async (order,orderPosition) => {
        console.log(`DEBUG  [checkProfileStatus] order:${order} defaultDeliveryNoteNumber ${this.state.defaultDeliveryNoteNumber}`);
        let deliveryNoteNumberInQry = this.state.setPlaceHolderValue? this.state.defaultDeliveryNoteNumber : this.state.deliveryNoteNumber;

        let orderPositionResult = await certblockAPI.callApi(
            'getOrderPositions',
            [order, deliveryNoteNumberInQry],
            'get'
        );

        let orderPositions = (orderPositionResult && orderPositionResult.data) ? 
            orderPositionResult.data.reduce((acc,el)=>(el.orderPosition == orderPosition)? ([...acc,el]) : acc,[])
        : [];
        // console.log(`orderPositions ${JSON.stringify(orderPositions)}`);
        return orderPositions;
    }

    updateStatuses = async () => {
        console.log(`DEBUG  [updateStatuses]`)
        this.setState({
            showLoadingModal: true
        });
        let materialsNew = this.state.materials;
        for(let i = 0; i < materialsNew.length; i++) {
            let material = materialsNew[i];
            let arrayOfProfiles = await this.checkProfileStatus(this.state.orderNumber, material.orderPosition);
            materialsNew[i].savedProfiles = arrayOfProfiles;
        }

        this.setState({
            materials: materialsNew,
            showLoadingModal: false
        },()=>{
        });
    }

    statusSaved = (material) => {
        // console.log(`DEBUG  [statusSaved]`);
        return material.savedProfiles && material.savedProfiles.length > 0;
    }

    getProfileNames = async (profiles, order, orderPosition, language) => {
        console.log(`DEBUG  [getProfileNames]`);
        let deliveryNoteNumber = this.state.setPlaceHolderValue? this.state.defaultDeliveryNoteNumber : this.state.deliveryNoteNumber;
        let profileNames = {};
        try {
            await Promise.all(profiles.map(async profile => {
                let profileName = await certblockAPI.callApi(
                    'getProfileName',
                    [order, deliveryNoteNumber, orderPosition, profile.profileNumber,language],
                    'get',
                );
                profileNames[profile.profileNumber] = profileName.data;
                }));
            let newProfiles = profiles.map((profile)=>{
                let newProfile = profile;
                newProfile.name = profileNames[profile.profileNumber].slice(0,MAX_PROFILE_NAME_LENGTH);
                return newProfile;
            });
            this.setState({
                docProfiles: newProfiles
            },()=>{
                console.log(this.state.docProfiles)
            })
        } catch(error){
            console.log('ERROR: ' + JSON.stringify(error));
            this.setState({
                showAPIErrorModal: true,
                showLoadingModal: false,
                showSavingModal: false,
                apiErrorMessage: globalMessages[localStorage.getItem('language')].searchDocuments.apiErrorMessageGetDocumentProfileName,
                apiErrorMessageForDevelopers: JSON.stringify(error) 
            });
        }
    }



    //@TODO @MARWAL check the logic if SN are allowed to be added based on API call results for given order and position 
    SNallowed = () => {
        return this.state.materialSelected?.SERIAL_ENABLED;
    }

    fillSNMatrix = (columnHeadersArray, numberOfInitialSN) =>{
        console.log(`DEBUG  [fillSNMatrix]`);
        var dict = {};
        var withoutSNdict = {};
        dict['SN'] = Array(numberOfInitialSN).fill("");
        withoutSNdict['SN'] = undefined;
        columnHeadersArray.forEach(header=>{
            dict[header] = Array(numberOfInitialSN).fill("");
            withoutSNdict[header] = undefined;
        });
        console.log('dict');
        console.log(dict);
        this.setState({
            addedSerialNumbersDict: dict,
            withoutSNdict: withoutSNdict
        });
    }

    getProfileNameForTP_DPROF370 = async(order,material) => {
        let deliveryNoteNumber = this.state.setPlaceHolderValue? this.state.defaultDeliveryNoteNumber : this.state.deliveryNoteNumber;
        let profileName = await certblockAPI.callApi(
            'getProfileName',
            [order, deliveryNoteNumber, material.orderPosition, TP_DPROF370 ,localStorage.getItem('language').slice(0,2)],
            'get',
        );
        return profileName;
    }

    handleShowUploadDocumentsModal = async (order, material) => {
        console.log(`DEBUG  [handleShowUploadDocumentsModal] order:${order} material:${JSON.stringify(material)}`);
        console.log(material)
        console.log(`material.TP_DPROF: ${material.TP_DPROF} BSTMG: ${material.BSTMG}`);
        let arrayProfiles = material.TP_DPROF.split(','); 
        let numberOfSN = material.BSTMG;
    
        await this.getProfileNames(arrayProfiles.map(profile=>{
            return {profileNumber:profile}
        }), order, material.orderPosition, localStorage.getItem('language').slice(0,2));

        console.log(`this.state.docProfiles`);
        console.log(this.state.docProfiles);
        this.fillSNMatrix(arrayProfiles,numberOfSN);
        this.setState({
            showLoadingModal: true,
            showAddSerialNumbersModal: true,
            materialSelected: material,
            useSerialNumbers: material.SERIAL_ENABLED
        });
        this.setState({
            showLoadingModal: false,
        });
    }


    async getMaterials(value, callback) {
        console.log('DEBUG [getMaterials]')
        try {
            let response = await certblockAPI.getMaterials(value,callback);
            return response;
        } catch(error) {
            console.log('ERROR: ' + JSON.stringify(error));
        }
    }

    async setUploadSlot(orderNumber, orderPosition, profileId){
        console.log(`DEBUG[setUploadSlot] (orderNumber, orderPosition, profileId): (${orderNumber}, ${orderPosition}, ${profileId})`);
        let deliveryNoteNumber = this.state.setPlaceHolderValue? this.state.defaultDeliveryNoteNumber : this.state.deliveryNoteNumber;
            try {
                let request = await certblockAPI.callApi(
                    'setUploadSlots',
                    [orderNumber, deliveryNoteNumber, orderPosition],
                    'post',
                    {'profileId' : profileId},
                )
                return request;
            }catch(error){
                console.log('DEBUG[setUploadSlot] Error:');
                console.log(error.message);
                this.setState({
                    showAPIErrorModal: true,
                    showLoadingModal: false,
                    showSavingModal: false,
                    apiErrorMessage: globalMessages[localStorage.getItem('language')].searchDocuments.apiErrorMessageSetUploadSlots,
                    apiErrorMessageForDevelopers: JSON.stringify(error) 
                });                
        }
    }

    //resolves the (ordered) array of files, that have been selected for a slot entry (profileId + serialNumber)
    getFilesForSlotEntry = (value) => {
        let SNallowed = this.SNallowed();
        let fileIndex = this.state.addedSerialNumbersDict['SN'].indexOf(value.serialNumber);
        let cell = (SNallowed && fileIndex != -1)? this.state.addedSerialNumbersDict[value.profileId][fileIndex] : this.state.withoutSNdict[value.profileId];
        return Array.isArray(cell)? cell : [];
    }

    async getUploadSlots(orderNumber, orderPosition, profileIdsWithSerialNumbers )
    {
        console.log('DEBUG[getUploadSlots]');
        let slots = {};
        try {
            await Promise.all(profileIdsWithSerialNumbers.map(async profileIdWithSerialNumber => {
                let profileId = profileIdWithSerialNumber.split('_')[0];
                let serialNumber = profileIdWithSerialNumber.split('_')[1];
                let entry = {profileId, serialNumber};
                let files = this.getFilesForSlotEntry(entry);
                // request one upload slot per selected file, keeping the order of the files so the backend
                // merges the resulting document in the expected page order.
                entry.fileSlots = await Promise.all(files.map(async file => {
                    let slot = await this.setUploadSlot(orderNumber, orderPosition, profileId);
                    return {
                        file,
                        slotId: slot.data.slotId,
                        presignedUrl: slot.data.presignedUrl,
                        status: slot.data.status
                    };
                }));
                slots[profileIdWithSerialNumber] = entry;
            }));
        } catch(error){
            console.log('DEBUG[getUploadSlots] ERROR:');
            console.log(error)
        }
        return slots;
    }

    saveFilesToSlots = async (deliveryNoteNumber,slots) => 
    {   
        console.log('DEBUG[saveFilesToSlots]');

        for (const [key, value] of Object.entries(slots))
        {
            console.log(`profileId:${value.profileId} SN:${value.serialNumber} fileSlots: ${value.fileSlots.length}`);
            for (const fileSlot of value.fileSlots) {
                if (fileSlot.file && fileSlot.presignedUrl){
                    let response = await certblockAPI.callApi(
                        'uploadFile',
                        [deliveryNoteNumber],
                        'put', //method
                        '',    //data
                        {},     
                        fileSlot.presignedUrl,
                        fileSlot.file
                    );
                    fileSlot.uploadResuls = response;
                } else {
                    console.log(`slot: ${fileSlot.presignedUrl} is missing for file: ${fileSlot.file}`);
                }
            }
        };   
    }   

    async myWait(milisec) {
        return new Promise((resolve, reject) => {
            setTimeout(() => { resolve("B"); console.log('waited:' + milisec)}, milisec)
        });
    }

    //a slot entry needs another poll/assign cycle as long as it has not been assigned, yet
    getSlotsForAnotherPoll (slots) {
        console.log(`DEBUG[getSlotsForAnotherPoll]`);
        let notAssigned = {};
        for (const [key, value] of Object.entries(slots)) {
            if (value.assignResult != apiFlagASSIGN_UPLOAD_COMPLETE){
                notAssigned[key] = value;
            }
        }   
        console.log(notAssigned); 
        return notAssigned;
    }    

    async poll(orderNumber, deliveryNoteNumber, orderPosition, slots){
        console.log('DEBUG[poll]');
        for (const [key, value] of Object.entries(slots))
        {
            for (const fileSlot of value.fileSlots) {
                if (fileSlot.file && fileSlot.presignedUrl){
                    let response = await certblockAPI.callApi(
                        'pollingFiles',
                        [orderNumber, deliveryNoteNumber, orderPosition, fileSlot.slotId],
                        'get', 
                    );
                    fileSlot.pollingResult = response;
                    fileSlot.pollingResultStatus = response.data.status;
                }
            }
        };   
    }

    async assignFiles(orderNumber, deliveryNoteNumber, orderPosition, slots){ 
        console.log('DEBUG[assignFiles]');
        let SNallowed = this.SNallowed();
        for (const [key, value] of Object.entries(slots)){
            let profileId = value.profileId;
            let SN = value.serialNumber;
            console.log(`profileId: ${profileId} SN: ${SN}`);
            // a slot entry can only be assigned once every one of its files has finished processing.
            let allFinished = value.fileSlots.length > 0 && value.fileSlots.every(
                fileSlot => fileSlot.pollingResultStatus == apiFlagFINISHED_PROCESSING
            );
            if (allFinished) {
                let slotIds = value.fileSlots.map(fileSlot => fileSlot.slotId);
                let response;
                if (SNallowed) {
                    response = await certblockAPI.callApi(
                        'profileDocsAssignment',
                        [orderNumber, deliveryNoteNumber, orderPosition, profileId],
                        'put',
                        {
                            'slotIds': slotIds,
                            'serialNumber' : SN
                        } 
                    );                    
                } else {
                    response = await certblockAPI.callApi(
                        'profileDocsAssignment',
                        [orderNumber, deliveryNoteNumber, orderPosition, profileId],
                        'put',
                        {
                            'slotIds': slotIds
                        } 
                    );                       
                }
                value.assignResponse = response;
                value.assignResult = response.data.message;
            } else {
                value.assignResult = 'NOT_ASSIGNED_YET'
            }
        }
    }

    handleSaveSerialNumbers = async () => {
        console.log(`DEBUG  [handleSaveSerialNumbers] `);
        this.setState({showAddSerialNumbersModal: false})
        // console.log(`SN: ${this.state.orderNumber} OrderPos: ${this.state.materialSelected.orderPosition}`);
        // console.log('addedSerialNumbersDict');
        // console.log(this.state.addedSerialNumbersDict);
        // console.log('withoutSNdict');
        // console.log(this.state.withoutSNdict);
        // console.log('to save here');
        this.saveDocumentsProfiles(this.state.orderNumber,this.state.materialSelected.orderPosition, this.state.materialSelected);
    }    

    prepareArrayWithSerialNumbers = (materialSelected) => {
        console.log('DEBUG[prepareArrayWithSerialNumbers]');
        let arrayProfiles = [];
        let SNallowed = this.SNallowed();
        let filesUploaded = SNallowed? this.state.addedSerialNumbersDict : this.state.withoutSNdict;  
        let autoSufix = false;             
        // console.log(this.state.docProfiles);
        // console.log(filesUploaded);
        this.state.docProfiles.forEach((profile)=>{
            let profileNumber = profile.profileNumber;
            if (SNallowed) {
                filesUploaded[profileNumber].forEach((fileSlot, idx)=>{
                    if(this.cellHasFiles(fileSlot)){
                        // let number = profileNumber + '_' + (filesUploaded['SN'][idx]? filesUploaded['SN'][idx] : 'auto-' + idx);
                        let sufix = '';
                        if(filesUploaded['SN'][idx]){
                            sufix = filesUploaded['SN'][idx];
                        } else {
                            sufix = 'auto-' + idx;
                            filesUploaded['SN'][idx] = sufix;
                            autoSufix = true;
                        }
                        let number = profileNumber + '_' + sufix;
                        arrayProfiles.push(number);
                    }
                });
            } else {
                if (this.cellHasFiles(filesUploaded[profileNumber])) arrayProfiles.push(profileNumber);
            }
        });

        //addinf 370 profile GOES here @TODO MARWAL
        let TP_DPROF15included = (this.state.docProfiles.filter(profile => profile.profileNumber == TP_DPROF15).length) >= 1;
        if (TP_DPROF15included && materialSelected.PROF370_DELETED) {
            // console.log('PROF370_DELETED and should be added again');
            filesUploaded[TP_DPROF370] = filesUploaded[TP_DPROF15];
            if (SNallowed) {
                filesUploaded[TP_DPROF370].forEach((fileSlot, idx)=>{
                    if(this.cellHasFiles(fileSlot)){
                        let sufix = '';
                        if(filesUploaded['SN'][idx]){
                            sufix = filesUploaded['SN'][idx];
                        } else {
                            sufix = 'auto-' + idx;
                            filesUploaded['SN'][idx] = sufix;
                            autoSufix = true;
                        }
                        let number = TP_DPROF370 + '_' + sufix;
                        arrayProfiles.push(number);
                    }
                });
            } else {
                if (this.cellHasFiles(filesUploaded[TP_DPROF370])) arrayProfiles.push(TP_DPROF370);
            }
            this.setState({
                addedSerialNumbersDict: filesUploaded
            });   
            return(arrayProfiles);
        }


        if(autoSufix && SNallowed){
            this.setState({
                addedSerialNumbersDict: filesUploaded
            });                                                                                                                                 
        }
        return(arrayProfiles);
    }
    
    async saveDocumentsProfiles (orderNumber, orderPosition, materialSelected) { 
        console.log('DEBUG[saveDocumentsProfiles]');
        let deliveryNoteNumber = this.state.setPlaceHolderValue? this.state.defaultDeliveryNoteNumber : this.state.deliveryNoteNumber; 

        this.setState({
            showSavingModal: true
        });

        let profileIdsWithSerialNumbers = this.prepareArrayWithSerialNumbers(materialSelected);
        // console.log(profileIdsWithSerialNumbers);
        // console.log(this.state.addedSerialNumbersDict['SN']);

        // console.log('getting files slots');
        let slots = await this.getUploadSlots(orderNumber, orderPosition, profileIdsWithSerialNumbers);
        // console.log(slots);


        // console.log('saving files to the slots');
        await this.saveFilesToSlots(deliveryNoteNumber,slots);
        // console.log(slots);  //LOOK FOR .UploadResults 
        

        let totalWaitedTime = 0;
        let numberOfSlots = Object.keys(slots).length;
        while(numberOfSlots > 0 && totalWaitedTime < MAX_TIME_WAITED) {
            await this.myWait(2000);
            totalWaitedTime += 2000; 
            // console.log('polling');
            await this.poll(orderNumber, deliveryNoteNumber, orderPosition, slots);
            // console.log(slots); //LOOK FOR pollingResult and pollingResultStatus

            // abort the whole upload if the virus scan of any file failed
            if (this.hasFailedFileSlot(slots)) {
                this.setState({
                    showSavingModal: false,
                    showAPIErrorModal: true,
                    apiErrorMessage: globalMessages[localStorage.getItem('language')].searchDocuments.apiErrorMessageSetUploadSlots
                });
                return;
            }

            // console.log(`waited: ${totalWaitedTime} numberOfSlots: ${numberOfSlots} profileIds.length: ${profileIds.length}`);
            // console.log('assigning');
            await this.assignFiles(orderNumber, deliveryNoteNumber, orderPosition, slots);
            // console.log(slots); //LOOK FOR assignResult
            
            // console.log('getSlotsForAnotherPoll');
            slots = this.getSlotsForAnotherPoll(slots);
            numberOfSlots = Object.keys(slots).length;
            // console.log(slots);
        }
    
        await this.updateStatuses();
        this.setState({
            showSavingModal: false
        });
    }

    //returns true as soon as any single uploaded file failed the virus scan, so the whole upload can be aborted
    hasFailedFileSlot (slots) {
        for (const value of Object.values(slots)) {
            if (value.fileSlots.some(fileSlot => fileSlot.pollingResultStatus == apiFlagERROR_PROCESSING)) {
                return true;
            }
        }
        return false;
    }

    getOrderNumbersPrefix = async (orderNumberPrefix) => {
        console.log(` MARWAL DEBUG[getOrderNumbersPrefix] prefix: ${orderNumberPrefix}`);
        this.setState({isLoadingPrefix: true});
        try {
			let orderNumberSearchOptions = (await certblockAPI.callApi('orderList', [orderNumberPrefix])).data;
			this.setState({orderNumberSearchOptions}, () => this.setState({isLoadingPrefix: false}))
            // //this.setState({isLoadingPrefix: false});
			// let orderList = await orderService.getOrderList({orderNumberPrefix});
			// console.log("orderlist", orderList);
			// return orderList;
            // return orderService.getOrderList({orderNumberPrefix});

        } catch (e) {
            console.log('MARWAL DEBUG[getOrderNumbersPrefix] Error:');
            console.log(e);
            this.setState({isLoadingPrefix: false});
            this.setState({
                showAPIErrorModal: true,
                showLoadingModal: false,
                showSavingModal: false,
                apiErrorMessage: globalMessages[localStorage.getItem('language')].searchDocuments.apiErrorMessageGetOrderNumberPrefix,
                apiErrorMessageForDevelopers: JSON.stringify(error)  
            });
        }
        return [];
    }

    getOrderNumbers = async () => {
        console.log(` MARWAL DEBUG[getOrderNumbers]`);
        try {
            let ordersList = (await certblockAPI.callApi('orderList', [])).data;
            if(!ordersList) {
                this.setState({
                    showAPIErrorModal: true,
                    showLoadingModal: false,
                    showSavingModal: false,
                    apiErrorMessage: globalMessages[localStorage.getItem('language')].searchDocuments.apiErrorMessageGetOrderNumbers,
                    // apiErrorMessageForDevelopers: JSON.stringify(ordersList) 
                });
                return;
            }

            if (ordersList.length > 0) {
                this.setState({ orderNumbersForSupplier: ordersList });
                // console.log('order(s) found ... create your certificate')
            } else {
                this.setState({ showAPIErrorModal: true, apiErrorMessage: globalMessages[localStorage.getItem('language')].createCertificate.uiErrorMessageFailAPICall });
            }
        } catch (e) {
            this.setState({
                showAPIErrorModal: true,
                showLoadingModal: false,
                showSavingModal: false,
                apiErrorMessage: globalMessages[localStorage.getItem('language')].searchDocuments.apiErrorMessageGetOrderNumbers,
                apiErrorMessageForDevelopers: JSON.stringify(e) 
            });
            return;
        }
    }


    render = () => {

        return (
            <>
                <NavBar />
                <FormErrors formErrors={this.state.formErrors} />
                {this.state.isSiemensOrSupplier &&
                    <div className="container col-xl-10 col-lg-10 col-md-9 col-sm-10">
                        {/* <div className="container col-xl-9 col-lg-9 col-md-12 col-sm-12"> */}
                        {/* <form onSubmit={this.handleSubmit}>     --> not needed here and would prevent that "handleKeyUp"-event is executed/handled!*/}
                        <h2><FormattedMessage id="uploadDocuments.formTitle" /></h2>

                        <div className="card" style={{ padding: 5, marginTop: 30 }}>
                            <div className="form-row">
                                <div className="form-group col-md-9 col-sm-12">
                                    <label htmlFor="deliveryNoteNumberInput"><FormattedMessage id="uploadDocuments.formDeliveryNoteNumber" /></label>
                                    <input name="deliveryNoteNumber" type="text" 
                                        onChange={this.handleChange} 
                                        onKeyUp={this.handleKeyUp} 
                                        className="form-control" id="deliveryNoteNumberInput" 
                                        placeholder={globalMessages[localStorage.getItem('language')].uploadDocuments.formDeliveryNoteNumberPlaceholder} 
                                        disabled={this.state.setPlaceHolderValue}/>
                                    <div className="invalid-feedback"><FormattedMessage id="showCertificate.formOrderNumber" /> {this.state.formErrors.orderNumber}</div>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group col-md-9 col-sm-10">
                                    <label>
                                        <input name='setPlaceHolderValue' type="checkbox" checked={this.setPlaceHolderValue} onChange={this.handleChange} />
                                        <FormattedMessage id="uploadDocuments.formCheckboxSetPlaceHolderValue" /> 
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="card" style={{ padding: 5, marginTop: 30 }}>
                            <div className="form-row">
                                <div className="form-group col-md-9 col-sm-10">
                                    <label htmlFor="orderNumberInput"><FormattedMessage id="uploadDocuments.formOrderNumber" /></label>
                                    <AsyncTypeahead
                                            onChange={this.handleChangeOrderNumber}
                                            id="orderNumberInput"
                                            isLoading={this.state.isLoadingPrefix}
                                            emptyLabel={globalMessages[localStorage.getItem('language')].createCertificate.emptySearchLabel}
                                            value={this.state.orderNumber}
                                            inputProps={{ className: `form-control ${this.errorClass(this.state.formErrors.orderNumber)}` }}
                                            placeholder={globalMessages[localStorage.getItem('language')].createCertificate.formOrderNumberPlaceHolder}
											options={this.state.orderNumberSearchOptions}
											onSearch={async (prefix) => this.getOrderNumbersPrefix(prefix)}/>
                                    {/* <input name="orderNumber" type="text" onChange={this.handleChange} onKeyUp={this.handleKeyUp} className="form-control" id="orderNumberInput" placeholder={globalMessages[localStorage.getItem('language')].uploadDocuments.formOrderNumberPlaceHolder} /> */}
                                    <div className="invalid-feedback"><FormattedMessage id="uploadDocuments.formOrderNumber" /> {this.state.formErrors.orderNumber}</div>
                                </div>
                                {/* <div className="form-group col-md-3 col-sm-12 d-flex justify-content-center" style={{ marginTop: 31 }}>
                                    <button type="button" onClick={this.getCertificates} className="btn btn-primary" style={{ whiteSpace: 'normal' }}><FormattedMessage id="uploadDocuments.formShowCertificatesBtn" /></button>
                                </div> */}
                            </div>
                        </div>

                        <div className="card" style={{padding: 5, marginTop: 30}} >
                            <div id="normalMode">
                                <label htmlFor="orderNumberInput"><FormattedMessage id="createCertificate.formMaterialFromOrderNum" /></label>                                
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col"><FormattedMessage id="uploadDocuments.formOrderPosition" /></th>
                                            <th scope="col"><FormattedMessage id="uploadDocuments.formQuantity" /></th>
                                            <th scope="col"><FormattedMessage id="uploadDocuments.formMaterialNumber" /></th>
                                            <th scope="col"><FormattedMessage id="uploadDocuments.formMaterialDesc" /></th>
                                            <th scope="col"><FormattedMessage id="uploadDocuments.formActions" /></th>
                                            <th scope="col"><FormattedMessage id="uploadDocuments.status" /></th>
                                            <th scope="col" />
                                        </tr>
                                    </thead>  
                                    <tbody>
                                        {this.state.materials.sort((a,b)=>{
                                            if(a.orderPosition < b.orderPosition) {return -1}
                                            return 1
                                        }).map((material, index) =>{
                                            return (
                                                <tr key={'_'+index} className="pdfItemMaterialList">
                                                    <td>{material.orderPosition}</td>
                                                    <td>{material.quantity}</td>
                                                    <td>{material.materialNumber}</td>
                                                    <td>{material.materialDescription}</td>
                                                    <td>
                                                        {(this.state.deliveryNoteNumber || this.state.defaultDeliveryNoteNumber !== "") && material.TP_DPROF != null ?
                                                            <button type="button" value={index} onClick={()=>{this.handleShowUploadDocumentsModal(this.state.orderNumber, material)}} id={'addButton' + index} className="btn" disabled={false} style={{ padding: 4 , backgroundColor: 'white', borderColor: 'lightblue'}}>
                                                                <MdCloudUpload   size={15} />&nbsp;<FormattedMessage id="uploadDocuments.uploadButton" />
                                                            </button> :
                                                            <>
                                                                <button type="button" className="btn" disabled={true} style={{ padding: 4 , backgroundColor: 'white', borderColor: 'lightblue'}}>
                                                                    <MdCloudUpload   size={15} />&nbsp;<FormattedMessage id="uploadDocuments.uploadButton" />
                                                                </button><br/>
                                                                {(material.TP_DPROF != null)? 
                                                                    <Badge bg={"danger"} pill={true} style={{color: "#fff"}}><FormattedMessage id="uploadDocuments.chooseDeliveryNoteNumber" /></Badge> :
                                                                    <Badge bg={"info"} pill={true} style={{color: "#fff"}}><FormattedMessage id="createCertificate.noUploadExpected" /></Badge>
                                                                }
                                                            </> 
                                                        }
                                                    </td>
                                                    <td>
                                                        <form key={'_'+index+'_satus'}>
                                                            <label className="btn" disabled={true} >
                                                                <MdCheckBox  hidden={!this.statusSaved(material)} size="1.25em"/>
                                                                <MdCheckBoxOutlineBlank  hidden={this.statusSaved(material)} size="1.25em"/>
                                                            </label>    
                                                        </form>
                                                    </td>
                                                </tr>
                                            )               
                                        })}
                                    </tbody>                                  
                                </table>
                            </div>
                        </div>
                    </div>
                }
                <br/>
                <div>
                    <LoadingComponent hidden={this.state.showLoadingModal} />
                </div> 
                <div>
                    <SavingComponent hidden={this.state.showSavingModal} />
                </div> 
                <div>
                    <Modal animation={false} show={this.state.showAPIErrorModal}>
                        <ModalHeader>
                            <Modal.Title><FormattedMessage id="uploadDocuments.uiErrorMessageFailTitleAPICall" /></Modal.Title>
                        </ModalHeader>    
                        <Modal.Body>
                            <div>{this.state.apiErrorMessage}</div>
                            <div>{this.state.apiErrorMessageForDevelopers}</div>
                        </Modal.Body>    
                        <Modal.Footer>
                            <Button 
                            onClick={()=>{this.setState({showAPIErrorModal: false})}}><FormattedMessage id="uploadDocuments.closeButton" /></Button>
                        </Modal.Footer>                
                    </Modal>
                </div>   
                <div className='container'>
                    {/*<DocumentUploadModal*/}
                    {/*    show={true}*/}
                    {/*    orderNumber={"3204036307"}*/}
                    {/*    deliveryNoteNumber={"20250721"}*/}
                    {/*    orderPosition={"00030"}*/}
                    {/*    positionCount={12}*/}
                    {/*/>*/}
                    <Modal  animation={false} show={this.state.showAddSerialNumbersModal} >
                        <ModalHeader>
                            <Modal.Title><FormattedMessage id="uploadDocuments.modalSerialNumberTitle" /> {this.state.materialSelected?.materialDescription}</Modal.Title>
                        </ModalHeader>    
                        <Modal.Body id="modalAddSerialNumbers">
                            <div className='row'
                                style={{justifyContent: 'space-between', display: 'flex', padding: '5px'}}
                            >
                            <label>
                            </label>
                            {(this.state.useSerialNumbers) && 
                            <label>
                                <Toggle
                                    defaultChecked={this.state.serialNumberAutoInc}
                                    icons={false}
                                    onChange={this.handleSerialNumberAutoIncChange}
                                    style={{justifyContent: "flex-end"}}
                                />
                                <span><FormattedMessage id="uploadDocuments.autoIncrement" /></span>
                            </label>           
                            }
                            </div>
                            <div style={{
                                backgroundColor: 'rgb(191 219 254 / var(--tw-border-opacity, 1))',
                                color: 'rgb(30 64 175 / var(--tw-text-opacity, 1))',
                                display: 'inline-block',
                                width: '100%',
                                // justifyCcontent: 'space-around',
                                overflow: 'hidden',
                                padding: (this.state.useSerialNumbers)? '5px' : '0px',
                                minHeight: '50px',
                                alignContent: 'center',
                                paddingLeft: '1em'
                            } }>
                            {(this.state.useSerialNumbers) &&
                                <>
                                <span ><FormattedMessage id="uploadDocuments.enterSerialNumbers" /></span>
                                <span><br/></span>
                                <span><FormattedMessage id="uploadDocuments.autoincrementDescription" /></span>
                                </>
                            }
                            {(!this.state.useSerialNumbers) &&
                                <>
                                <span ><FormattedMessage id="uploadDocuments.uploadForEachDocumentType" /></span>
                                <span> </span>
                                <span><br/></span>
                                </>
                            }
                            </div>
                            <thead className="table" id="serialNumbers" style={{width: '100%', alignItems:'center'}}>
                                <tr>
                                    {/* {this.SNallowed() && <th scope="col" style={{backgroundColor: 'lightgrey', textAlign: 'center'}}>{' '}</th>} */}
                                    {this.SNallowed() && <th scope="col" style={{backgroundColor: 'rgb(229 231 235 / var(--tw-border-opacity, 1))', textAlign: 'center'}}>{' '}</th>}
                                    {this.state.addedSerialNumbersDict && this.state.docProfiles && this.state.docProfiles.map((profile,idx)=>{
                                        return (
                                            <th scope="col" 
                                                style={{
                                                    border: '1px solid white',
                                                    backgroundColor: 'rgb(219 234 254 / var(--tw-bg-opacity, 1)', 
                                                    color: 'rgb(30 64 175 / var(--tw-bg-opacity, 0.5))',
                                                    textAlign: 'center',  
                                                    whiteSpace: 'pre-line'
                                                    }}
                                            >
                                              {this.adjustHeader(profile.name, this.state.docProfiles.length)}
                                            <br/> 
                                            </th>
                                        );    
                                    })}
                                </tr>
                            </thead> 
                            <tbody className="table" id="serialNumbers" style={{width:'100%', alignItems:'center'}}>
                                <tr>
                                    {Object.keys(this.state.addedSerialNumbersDict).map((header,idx)=>{                                  
                                            if(idx !=0)
                                                return (  
                                                    <td key={header + '_' + idx}>
                                                        <label className="btn btn-secondary" 
                                                        style={{
                                                            width:'100%', 
                                                            alignItems:'center',
                                                            backgroundColor: this.SNallowed()? (this.alreadySelected(header,-1)? 'rgb(240 253 244 / var(--tw-bg-opacity, 1))' : 'rgb(219 234 254 / var(--tw-bg-opacity, 1)') : (this.alreadySelected(header,-1)? 'rgb(240 253 244 / var(--tw-bg-opacity, 1))' :'rgb(249 250 251 / var(--tw-bg-opacity, 1))'),
                                                            color:  this.SNallowed()? (this.alreadySelected(header,-1)? 'rgb(21 128 61 / var(--tw-text-opacity, 1))' : 'rgb(30 64 175 / var(--tw-bg-opacity, 0.5))') : (this.alreadySelected(header,-1)? 'rgb(21 128 61 / var(--tw-text-opacity, 1))' : 'rgb(55 65 81 / var(--tw-text-opacity, 1))'),
                                                        }} 
                                                        htmlFor={header+'_'+'all'+'_'+idx}>
                                                            {this.SNallowed()? <FormattedMessage id="uploadDocuments.forAllSerialNumbers" />  : <FormattedMessage id="uploadDocuments.uploadButton" /> }
                                                        {/* <label className="btn btn-primary" htmlFor={header} style={{backgroundColor: this.state.selectedFiles[profile.profileNumber+'_'+addedNumber]? uploadPdfButtonColor: ''}}>{profile.profileNumber}<MdAttachFile size="1.25em"/> */}
                                                            <input 
                                                                id={header+'_'+'all'+'_'+idx} 
                                                                type="file" 
                                                                multiple name={header} 
                                                                onChange={this.handleFileChange} 
                                                                style={{display: 'none'}}
                                                                serialNumber={this.state.materialSelected?.serialNumber}
                                                                col={header} 
                                                                row={-1} //-1 meaning to set for all the rows
                                                                orderPosition={this.state.materialSelected?.orderPosition}
                                                            />
                                                        </label> 
                                                    </td>
                                                );
                                            else {
                                                return (
                                                    this.SNallowed() && 
                                                    <td key={header + '_' + idx}
                                                        // className='btn btn-light'
                                                        // onClick={()=>{console.log(`Upload for all SN idx=${idx}`)}}
                                                        style={{with:'fit-content'}}
                                                    >
                                                        {/* className="btn btn-light" */}
                                                        <label  htmlFor={header}>
                                                            <FormattedMessage id="uploadDocuments.allSNFiles" />
                                                        </label> 
                                                    </td>
                                                );
                                            }
                                    })}
                                </tr>
                                {this.state.useSerialNumbers && 
                                 this.state.addedSerialNumbersDict['SN'] && 
                                 this.state.addedSerialNumbersDict['SN'].map((sn,row)=>{
                                    return(
                                    <tr>
                                        {Object.keys(this.state.addedSerialNumbersDict).map((header,col) =>{
                                            if(col == 0 ) {
                                                return (
                                                    <td key={row + '_' + col}>
                                                    <input 
                                                        id={"serialNumberId" + "_" + row}
                                                        name="serialNumber" 
                                                        type="text" 
                                                        maxLength={32} 
                                                        size={20}
                                                        value={this.state.addedSerialNumbersDict['SN'][row]}
                                                        onChange={(e) => this.handleAddSerialNumberChanged(e,row)}
                                                        onMouseLeave={()=>{if(row === 0 && this.state.serialNumberAutoInc) this.handleAddDefaultSerialNumbers();}}
                                                    />
                                                    </td>
                                                )
                                            }
                                            return (
                                            <td key={row + '_' + col}
                                                onClick={()=>{console.log(`(row,col) = (${row},${col})`)}}
                                            >
                                                {/* {col} */}
                                                <label 
                                                    className="btn btn-secondary" 
                                                    htmlFor={header+'_'+row+'_'+col}
                                                    style={{
                                                        width:'100%', 
                                                        alignItems:'center',
                                                        backgroundColor: this.alreadySelected(col,row)? 'rgb(240 253 244 / var(--tw-bg-opacity, 1))' : 'rgb(249 250 251 / var(--tw-bg-opacity, 1))',
                                                        color:  this.alreadySelected(col,row)? 'rgb(21 128 61 / var(--tw-text-opacity, 1))' :'rgb(55 65 81 / var(--tw-text-opacity, 1))',
                                                    }}
                                                >
                                                    {/* <><MdCloudUpload size="1.0em"/>Upload File</> */}
                                                    Upload File
                                                        {/* <label className="btn btn-primary" htmlFor={header} style={{backgroundColor: this.state.selectedFiles[profile.profileNumber+'_'+addedNumber]? uploadPdfButtonColor: ''}}>{profile.profileNumber}<MdAttachFile size="1.25em"/> */}
                                                    <input 
                                                        id={header+'_'+row+'_'+col} 
                                                        type="file" 
                                                        multiple name={header} 
                                                        onChange={this.handleFileChange} 
                                                        style={{display: 'none'}} 
                                                        serialNumber={this.state.materialSelected?.serialNumber}
                                                        col={header} 
                                                        row={row} 
                                                        orderPosition={this.state.materialSelected?.orderPosition}
                                                    />
                                                </label> 
                                            </td>);
                                        })}
                                    </tr>
                                    )
                                })
                                }
                            </tbody> 
                            <button 
                                className="btn btn-secondary" 
                                style={{
                                    borderStyle: 'none',
                                    backgroundColor: 'rgb(240 253 244 / var(--tw-bg-opacity, 1))',
                                    color: 'rgb(21 128 61 / var(--tw-text-opacity, 1))'
                                }}
                            >{this.countSelectedFiles()} <FormattedMessage id="uploadDocuments.filesSelected" /></button>
                        </Modal.Body>    
                        <Modal.Footer>
                            <Button 
                                onClick={()=>{this.setState({showAddSerialNumbersModal: false})}}><FormattedMessage id="uploadDocuments.modalSerialNumberCancelButton" />
                            </Button>
                            <Button
                                onClick={this.handleSaveSerialNumbers}
                            >
                                <FormattedMessage id="uploadDocuments.modalSerialNumberSaveButton" />
                            </Button>                            
                        </Modal.Footer>                
                    </Modal>
                </div>         
                <Footer />
            </>
        );
    }
}

export default UploadDocumentsContainer
